import React from "react";
import { Input } from "reactstrap";
import MaskedInput from "react-text-mask";

import api from "../services/Api";
import ModalConfirm from "./hoc/ModalConfirm";
import Loading from "./Loading";

export default class RedefineProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      modal: false,
      nomeOk: true,
      nascOk: true,
      contatoOk: true,
      nascRegex: [/[0-3]/, /\d/, "/", /[0-1]/, /\d/, "/", /[1-2]/, /\d/, /\d/, /\d/],
      contatoRegex: [
        "(",
        /\d/,
        /\d/,
        ")",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
      nome: "",
      datanasc: "",
      telefone: "",
      loading: true,
    };
    this.handleRedefine = this.handleRedefine.bind(this);
  }

  async componentWillMount() {
    await api
      .loadUserByUid(this.props.allUser.uid)
      .then((user) => {
        this.setState({
          nome: user.data[0].nome,
          datanasc: user.data[0].datanasc,
          telefone: user.data[0].telefone,
          nascOk: this.props.allUser.datanasc !== undefined,
          loading: false,
        });
      })
      .catch((error) => {
        console.log("ERROR LOAD USER BY ID:", error);
        this.props.onModalToken();
      });
  } //willMount

  handleIsValid = (key, evento) => {
    const campo = evento.target.id;
    const value = evento.target.value;

    this.setState({ [key]: value });

    const validNome = /^[A-zà-ú]{3,}\s[A-zà-ú]{2,}\s?([A-zà-ú]{2,})?\s?([A-zà-ú]{2,})?\s?([A-zà-ú]{2,})?$/;

    switch (campo) {
      case "inputNome":
        if (validNome.test(value) === true) {
          this.setState({ nomeOk: true });
        } else {
          this.setState({ nomeOk: false });
        }
        break;

      case "inputNasc":
        if (value.match(/^\d{2,}\/\d{2,}\/\d{4,}$/) !== null) {
          this.setState({ nascOk: true });
        } else {
          this.setState({ nascOk: false });
        }
        break;

      case "inputContato1":
        if (value.match(/^\(\d{2}\)\d{4,5}-\d{3,4}/) !== null) {
          this.setState({ contatoOk: true });
        } else {
          this.setState({ contatoOk: false });
        }
        break;
      default:
        break;
    }
  }; //Valid

  verificar = () => {
    if (this.state.nomeOk === true && this.state.nascOk === true && this.state.contatoOk === true) {
      return true;
    } else {
      return false;
    }
  };

  testingFunc = () => {
    alert("Preencha os campos em vermelho");
  };

  async handleRedefine() {
    const object = {
      nome: this.state.nome,
      datanasc: this.state.datanasc,
      telefone: this.state.telefone,
      cpf: this.props.allUser.cpf,
      genero: this.props.allUser.genero,
      email: this.props.allUser.email,
      foto: this.props.allUser.foto,
      uid: this.props.allUser.uid,
      id: this.props.allUser.id,
      local: this.props.allUser.local,
      nome_mae: this.props.allUser.nome_mae,
    };

    await api
      .updateUser(object)
      .then((user) => {
        this.props.handleShowForm("dispositivos");
        this.props.handleAlterPerfil(user.data);
      })
      .catch((err) => {
        // console.log('err response', err.response)
        if (err.response.status === 401) {
          this.props.onModalToken();
        }
      });
  }

  onModal = (event) => {
    this.setState({ modal: !this.state.modal });
  };

  render() {
    if (this.state.loading) return <Loading />;

    return (
      <div className="col-md-6">
        <h2>Editar Perfil</h2>
        <div className="form-group">
          <label htmlFor="inputAddress">Nome*</label>
          <Input
            invalid={!this.state.nomeOk}
            id="inputNome"
            placeholder="Nome completo"
            value={this.state.nome}
            onChange={(event) => this.handleIsValid("nome", event)}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="inputNasc">Data de nascimento*</label>
          <MaskedInput
            mask={this.state.nascRegex}
            showMask="true"
            invalid={!this.state.nascOk}
            id="inputNasc"
            onChange={(event) => this.handleIsValid("datanasc", event)}
            value={this.state.datanasc}
            render={(ref, props) => {
              return <Input innerRef={(input) => (this.datanasc = ref(input))} {...props} />;
            }}
          />
        </div>
        <div className="form-group ">
          <label htmlFor="inputContato1">Contato*</label>
          <MaskedInput
            mask={this.state.contatoRegex}
            showMask="true"
            invalid={!this.state.contatoOk}
            id="inputContato1"
            onChange={(event) => this.handleIsValid("telefone", event)}
            value={this.state.telefone}
            render={(ref, props) => {
              return <Input innerRef={(input) => (this.telefone = ref(input))} {...props} />;
            }}
          />
        </div>
        <button
          className="btn btn-primary btn-sm mr-2"
          onClick={this.verificar() === true ? this.onModal : this.testingFunc}
        >
          Salvar
        </button>
        &nbsp;
        <button
          className="btn btn-danger btn-sm"
          onClick={() => this.props.handleShowForm("dispositivos")}
        >
          Cancelar
        </button>
        <br />
        &nbsp;
        <ModalConfirm
          style={{ color: "black" }}
          title={this.state.ModalTitle}
          show={this.state.modal}
          toggle={this.onModal}
          ok={this.handleRedefine}
        >
          <p style={{ color: "black" }}>Tem certeza que deseja Alterar Seus Dados?</p>
        </ModalConfirm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RedefineProfile.js